export const CREATE_LINKS_OPERATION_NAME = 'createLinks' as const;
